<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">The author had an extensive aviation career as a military flight officer and as an International Captain with United Airlines.</p>
<p style="text-indent:00em; padding-top:15px;">He began his writing career at the urging of his wife, Roseanne as he often told her tales of his travels and adventures.</p>
<p style="text-indent:00em; padding-top:15px;">Captain Angelo is an author, movie script writer, film producer, Reality Show writer/producer with several books and film projects in development.</p>
<p style="text-indent:00em; padding-top:15px;">He resides with his wife in New England, USA.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?d19e1e9a